<template>
  <div id="Home" class="Page Home" v-if="response">

    <section id="Top" class="Section Banner">
        <div class="Banner_wrapper">
            <div class="Banner_content" :style="`background-image: url('${response[0].primary.quote_background.url}')`">
                <div class="Banner_text">
                    <h2>{{ response[0].primary.quote }}</h2>
                    <h3>{{ response[0].primary.author }}</h3>
                    <!-- <div class="Banner_link">
                      <a v-for="(link, i) in data.sections[0].links" :key="i" :href="link.href" v-html="link.label" class="Cta"></a>
                    </div> -->
                </div>
            </div>
        </div>
    </section>
    
    <section v-if="response[1].primary.communication_suptitle && response[1].primary.communication_title && response[1].primary.communication_paragraph" class="Section Communication">
      <img src="/assets/images/wave-top.svg"/>
      <div class="Communication_wrapper">
        <h3 v-if="response[1].primary.communication_suptitle">{{ response[1].primary.communication_suptitle }}</h3>
        <h2 v-if="response[1].primary.communication_title">{{ response[1].primary.communication_title }}</h2>
        <prismic-rich-text class="Paragraph" field="presentation_paragraph" :field="response[1].primary.communication_paragraph" />
      </div>
      <img src="/assets/images/wave-down.svg"/>
    </section>

    <section class="Section Intro">
      <div class="Intro_wrapper">
        <img src="/assets/images/wave-top.svg"/>
        <h3>{{ response[2].primary.presentation_title }}</h3>
        <h2>{{ response[2].primary.presentation_brand }}</h2>
        <prismic-rich-text class="Paragraph" field="presentation_paragraph" :field="response[2].primary.presentation_paragraph" />
        <div class="Banner_link" v-if="response[2].primary.booking_link && response[2].primary.booking_label">
            <a :target="response[2].primary.booking_link.target" :href="response[2].primary.booking_link.url" class="Cta" >{{ response[2].primary.booking_label }}</a>
        </div>
        <img src="/assets/images/wave-down.svg"/>
      </div>
    </section>

    <PrestaList :data="response[3]"/>

    <section class="Section RDV">
        <div class="RDV_wrapper">
            <div class="RDV_content" :style="`background-image: url('${response[4].primary.schedule_image.url}')`">
                <div class="RDV_text">
                    <h3>{{ response[4].primary.schedule_title }}</h3>
                    <h2>{{ response[4].primary.schedule_label }}</h2>
                    <prismic-rich-text field="schedule_paragraph" :field="response[4].primary.schedule_paragraph" />
                    <div class="Banner_link">
                        <a :href="'/' + response[4].primary.link_target" class="Cta" >{{ response[4].primary.schedule_label_link }}</a>
                    </div>
                    <div class="Banner_link" v-if="response[4].primary.booking_link && response[4].primary.booking_label">
                        <a :target="response[4].primary.booking_link.target" :href="response[4].primary.booking_link.url" class="Cta" >{{ response[4].primary.booking_label }}</a>
                    </div>
                </div>
            </div>
        </div>
    </section>

  </div>
</template>

<script>
import Vue from 'vue'
import page from "@/mixins/page"
import prismicFetch from "@/mixins/prismicFetch";

import PrestaList from "@/components/PrestaList"
import ScrollParallax from "@/components/ScrollParallax"
import Fade from "@/components/Fade"
import Footer from "@/components/partials/Footer"

export default {
  components: {
    PrestaList,
    ScrollParallax,
    Fade
  },
  mixins: [ page, prismicFetch ],
  data () {
    return {
      data: null
    }
  },
  head: {
    title: {
      inner: "So Beautiful By Sarah",
      separator: '/',
      complement: 'Home'
    }
  },
  /*
  beforeRouteEnter (to, from, next) {
    Vue.$api.getHome()
      .then(response => {
        next(vm => vm.setData(response.data.data))
      })
  },
   */
  methods: {
    setData (data) {
      this.data = data
      this.$nextTick( () => {
        document.dispatchEvent(new Event('render-trigger'))
      })
    }
  },
  created () {
      this.getContent('homepage')
  },
  mounted () {
  }
}
</script>

<style lang="stylus" scoped>
.Home

  .Banner
    background-color $darker-beige

    &_wrapper
      background-color $darker-beige
      height calc(100vh - 250px)
      max-height 575px
      min-height 300px

      @media $small
        max-height 320px

      @media $xsmall
        height calc(100vh - 140px)

    &_content
      //background-image url('../../public/assets/images/cover-banner2.jpg')
      background-position center
      background-size cover
      background-repeat no-repeat
      position absolute
      width 90%
      max-width $max-width
      height calc(100vh - 120px)
      max-height 750px
      min-height 400px
      top 92px
      left 50%
      transform translate(-50%)

      @media $medium
        top 85px
        transform translate(-50%, -85px)

      @media $small
        height calc(100vh - 20px)
        max-height 430px
        top 72px
        transform translate(-50%, -72px)

    &_text
      color $light-brown
      font-size 20px
      position relative
      max-width 540px
      top 70%
      left 90%
      transform translate(-80%, -50%)

      @media $medium
        margin-left 30px

      @media $small
        left 0
        transform translateX(0)
        top 90%
        transform translateY(-90%)

      @media $xsmall
        padding-right 15px
        padding-left 25px
        padding-top 30px
        max-width 320px
        width 90%
        margin 0

      h2
        margin-bottom 15px

        @media $medium
          margin-bottom 10px

        @media $small
          margin-bottom 8px

      .Cta
        margin-right 20px

        @media $small
          margin-right 10px
          margin-bottom 10px

  .Communication
    text-align center
    padding 140px 0 0

    @media $small
      padding 60px 0 0

    &_link
      margin-bottom 20px
    
    &_wrapper
      width 90%
      margin 0 auto
      background #f9e6d7
      color $dark-brown
      padding 20px
      border-radius 20px

      @media $small
        padding 10px

      p
        color $dark-brown

    div
      margin-bottom 30px

    h3
      color $light-brown
      margin-top 20px

    h2
      color $dark-brown

    img
      position relative
      width 350px

      &:first-child
        left 90px
        top 30px
        transform translateY(-20px)

        @media $xsmall
          left 50px

      &:last-child
        right 90px
        bottom 20px
        transform translateY(-20px)

        @media $xsmall
          right 50px

      @media $small
        width 250px

      @media $xsmall
        width 200px
  

  .Intro
    color $dark-brown
    background $beige
    text-align center
    padding 140px 0 90px

    @media $small
      padding 60px 0 20px

    &_link
      margin-bottom 20px

    &_wrapper
      width 500px
      margin 0 auto

      @media $small
        width 90%
        padding 0

    div
        margin-bottom 30px

    h3
      color $light-brown

    img
      position relative
      width 350px

      &:first-child
        left 90px
        top 20px
        transform translateY(-20px)

        @media $xsmall
          left 50px

      &:last-child
        right 90px
        top 20px
        transform translateY(-20px)

        @media $xsmall
          right 50px

      @media $small
        width 250px

      @media $xsmall
        width 200px

  .RDV

    &_content
      //background-image url('../../public/assets/images/cover-rdv.jpg')
      background-position 50% 0%
      background-size cover
      background-repeat no-repeat
      width 100%
      margin 0 auto
      height calc(100vh - 120px)
      max-height 750px

      @media $medium
        max-height 550px

    &_text
      color $dark-brown
      position relative
      top 20%
      width 500px
      margin 0 auto
      text-align center
      transform translateY(-20%)

      @media $small
        width 90%
        top 15%
        transform translateY(-15%)

      p
        margin-bottom 30px

      div
        margin-bottom 30px

      .Cta
        // margin-right 20px
</style>
